// removed by extract-text-webpack-plugin
module.exports = {"force-graph":"styles-module__force-graph___1bXQK","node":"styles-module__node___1VjCB","seed-node":"styles-module__seed-node___28xQq","link":"styles-module__link___2g0Uw"};


//////////////////
// WEBPACK FOOTER
// ./src/vis-modules/force-graph/components/ForceGraph/styles.module.css
// module id = 1071
// module chunks = 0